import { useEffect, useState } from "react";
import { TYPO } from "styles/Typo";

/** test.riskweather.io 또는 NEXT_PUBLIC_ADS_MOCK=true 일 때만 목업 노출 */
export function useAdsMockEnabled() {
  const envEnabled = process.env.NEXT_PUBLIC_ADS_MOCK === "true";
  const [enabled, setEnabled] = useState(envEnabled);

  useEffect(() => {
    if (envEnabled) {
      setEnabled(true);
      return;
    }
    setEnabled(window.location.hostname === "test.riskweather.io");
  }, [envEnabled]);

  return enabled;
}

type AdMockVariant = "display" | "sideRail" | "intent";

type AdMockProps = {
  variant?: AdMockVariant;
  className?: string;
  label?: string;
  /** display 변형 높이(px). 기본 250, 수평 배너는 Planner 태그(~56)에 맞춤 */
  height?: number;
};

function AdMock({
  variant = "display",
  className = "",
  label = "Ad · mock",
  height = 250,
}: AdMockProps) {
  const enabled = useAdsMockEnabled();
  if (!enabled) return null;

  if (variant === "sideRail") {
    return (
      <aside
        aria-hidden
        className={`hidden w-800:flex fixed top-24 z-20 flex-col items-center justify-center bg-gray10 border border-dashed border-gray40 text-gray50 ${className}`}
        style={{
          right: "max(16px, calc((100vw - 800px) / 2 - 176px))",
          width: 160,
          height: 600,
        }}
      >
        <span className={`${TYPO.TYPO8_MD}`}>{label}</span>
        <span className={`${TYPO.TYPO9_RG} mt-1`}>side rail</span>
      </aside>
    );
  }

  if (variant === "intent") {
    return (
      <div
        aria-hidden
        className={`mx-6 my-3 flex flex-wrap items-center gap-2 ${className}`}
      >
        <span className={`${TYPO.TYPO8_RG} text-gray50`}>Ad · mock</span>
        <span className="inline-flex items-center rounded-full bg-gray10 border border-dashed border-gray40 px-3 py-1 text-gray60">
          <span className={`${TYPO.TYPO8_MD}`}>관련 키워드 · chip</span>
        </span>
        <span
          className={`${TYPO.TYPO8_MD} text-blue50 underline decoration-dotted`}
        >
          intent link
        </span>
      </div>
    );
  }

  // 본문과 동일하게 px-6 안쪽 full-width (리스트/카드 콘텐츠 폭과 정렬)
  const compact = height <= 80;
  return (
    <div
      aria-hidden
      className={`${compact ? "my-2" : "my-4"} w-full px-6 box-border ${className}`}
    >
      <div
        className="flex w-full flex-col items-center justify-center bg-gray10 border border-dashed border-gray40 text-gray50 rounded-[4px]"
        style={{ height, minHeight: height }}
      >
        <span className={`${compact ? TYPO.TYPO8_MD : TYPO.TYPO7_MD}`}>
          {label}
        </span>
        {!compact && (
          <span className={`${TYPO.TYPO8_RG} mt-1`}>display</span>
        )}
      </div>
    </div>
  );
}

export default AdMock;
